module.exports = __webpack_public_path__ + "static/media/ic-discount.7df6359c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-discount.svg
// module id = 621
// module chunks = 14